export default __webpack_public_path__ + "static/media/download.0a0c65ab.gif";